<template>
  <div class="toggle-switch">
    <input
      :id="id"
      :checked="modelValue"
      type="checkbox"
      @change="$emit('update:modelValue', $event.target.checked)"
    />
    <label :for="id" class="ts-helper" />
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
  },
  emits: ['update:modelValue'],
}
</script>
